var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.33 5.99979C32.1937 5.98575 32.0563 5.98575 31.92 5.99979H3.92001C3.74056 6.00256 3.56229 6.02947 3.39001 6.07979L17.84 20.4698L32.33 5.99979Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.81 7.39014L19.25 21.8901C18.8753 22.2626 18.3684 22.4717 17.84 22.4717C17.3116 22.4717 16.8047 22.2626 16.43 21.8901L1.99999 7.50014C1.95563 7.66318 1.93211 7.83118 1.92999 8.00014V28.0001C1.92999 28.5306 2.14071 29.0393 2.51578 29.4144C2.89085 29.7894 3.39956 30.0001 3.92999 30.0001H31.93C32.4604 30.0001 32.9691 29.7894 33.3442 29.4144C33.7193 29.0393 33.93 28.5306 33.93 28.0001V8.00014C33.922 7.79179 33.8815 7.58597 33.81 7.39014ZM5.29999 28.0001H3.90999V26.5701L11.18 19.3601L12.59 20.7701L5.29999 28.0001ZM31.91 28.0001H30.51L23.22 20.7701L24.63 19.3601L31.9 26.5701L31.91 28.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b1a8058ba708765ec55d55ee06979b1e.svg";
export { ForwardRef as ReactComponent };